var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLuggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 82,
    viewBox: "0 0 85 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON LUGGAGE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.9911 53.357C81.9652 53.1109 81.9101 52.8436 81.8013 52.5746C76.8372 40.4944 72.1326 28.3089 67.7134 16.0298C67.3052 14.9119 66.44 14.4081 65.5274 14.3581C65.0026 14.1452 64.3814 14.1058 63.6991 14.3656C60.9759 15.3918 58.2433 16.4214 55.5166 17.4382C54.0681 16.4447 52.1208 16.2721 50.4234 16.4341C50.332 16.4462 50.2312 16.4617 50.1363 16.4644C49.4703 14.7275 48.776 13.0009 48.0347 11.2914C47.1778 9.29416 46.0817 7.34166 43.5854 7.44401C41.6102 7.51577 39.5441 8.62143 37.7183 9.27738C35.633 10.0388 33.5536 10.7873 31.4682 11.5487C29.4674 12.2792 27.4572 13.0131 25.4564 13.7436C24.3761 14.138 23.2959 14.5325 22.2156 14.9269C21.2199 15.2904 20.1917 15.6232 19.5111 16.4998C18.1404 18.2565 19.1869 20.8019 19.7557 22.6808C20.2268 24.2334 20.8234 25.7508 21.5071 27.2152C21.0052 27.59 20.5461 28.0238 20.1717 28.5437C19.7607 29.109 19.5129 29.7424 19.571 30.4557C19.5849 30.6103 19.621 30.7675 19.6571 30.9246C15.7161 32.4061 11.7658 33.8909 7.82485 35.3724C7.29882 35.5644 6.92159 35.8725 6.65038 36.2377C5.82927 36.8462 5.37095 37.8652 5.89627 39.0999C11.2936 51.8416 16.228 64.7736 20.68 77.8711C21.4355 80.0864 24.0061 79.925 25.1953 78.5753C43.9303 71.7776 62.6472 64.9014 81.341 57.991C83.5638 57.1688 83.3656 54.5265 81.9758 53.3732L81.9911 53.357Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.0447 20.6803C47.0447 20.6803 46.9552 17.5193 50.1363 16.4643L67.7094 63.0211",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.507 27.2153C21.507 27.2153 24.4108 25.7505 26.379 28.2256",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.9358 27.7188C21.9358 27.7188 36.851 65.7713 38.7409 73.7469",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.7333 32.4529C15.7333 32.4529 28.6101 28.4754 62.0838 15.1894",
    stroke: "#EF7056",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLuggage);
export default __webpack_public_path__ + "static/media/icon-luggage.c3f6eb10a7210d2b662ef620c349c0f0.svg";
export { ForwardRef as ReactComponent };